<template>
  <div class="headFixed" @click="hideSomething">
    <div class="detail_head fixed_head">
      <div>
        <div class="content">
          <div class="go_back">
            <span @click="goBack" class="goBackBtn"></span>
            {{ eqInfo ? eqInfo.name : '' }}
            <img v-show="eqInfo" @click="changeMenu" class="right menuImg" width="25"
                 src="../../../assets/images/menu.png" alt=""/>
          </div>
        </div>
      </div>
      <div class="menu" v-show="showMenu">
        <ul>
          <!--<router-link :to="'/equipment/info/'+this.getId()">-->
          <router-link :to="'/equipment/info/' + this.getId()">
            <li>设备信息</li>
          </router-link>

          <!--</router-link>-->
          <router-link :to="'/equipment/systemStatus/' + this.getId()" v-show="eqInfo && eqInfo.deviceType == 1">
            <li>设备状态</li>
          </router-link>
          <!--<li>设备密码</li>-->
          <li @click="eqUnbind">解除绑定</li>
        </ul>
      </div>
    </div>
    <div class="noInfo" v-show="showEmpty">暂无信息</div>
    <div v-show="true">
      <div class="eqInfoDetail" v-show="eqInfo">
        <div>
          <div class="detail_top">
            <span class="coolBg2"></span>
            <div></div>

            <div class="degrees">
              <canvas id="clock" width="220px" height="220px"></canvas>
              <canvas id="pointer" width="220px" height="220px"></canvas>
              <p :class="this.drawDegree == null ? 'noDegree' : ''">
                {{ this.drawDegree == null ? '暂无设置' : this.drawDegree + '%' }}
                <span class="type" v-if="eqInfo.dehumidification.dehumidificationMode === '1'"><span>新风</span></span>
                <span class="type"
                      v-else-if="eqInfo.dehumidification.dehumidificationMode === '0'"><span></span>自动</span>
                <span class="type" v-else><span></span>除湿</span>
              </p>
            </div>
          </div>
          <ul class="setDegree clear">
            <li class="left">
							<span class="text-center eqDegree">
								<span>
									{{
                    parseInt(eqInfo.dehumidification.homeCoolingHumiditySetting) ? parseInt(eqInfo.dehumidification.homeCoolingHumiditySetting) : 0
                  }}%
								</span>
								湿度设定
							</span>
            </li>
            <li class="right"><p class="setDegreeBtn" @click="showDegreeModel"></p>
            </li>
          </ul>
        </div>

        <div class="eqType">
          <ul class="clear">
            <!--          开关切换-->
            <li class="li-open" @click="eqStart"
                v-if="eqInfo.dehumidification.systemStatus === '0' ">
              <span></span>
              开机
            </li>
            <li v-if="eqInfo.dehumidification.systemStatus === '1'" class="li-open li-open2" @click="shutDownFan">
              <span></span>
              关机
            </li>
            <!--          切换模式-->
            <li class="li-mode" @click="changeEqMode">
              <span></span>
              模式
            </li>
            <li class="li-loop" @click="changeEqLoopMode">
              <span></span>
              循环
            </li>
            <li class="li4" @click="showWindSpeed">
              <span></span>
              风速
            </li>
            <li class="li-sterilization" @click="changeEqSterilazation">
              <span></span>
              杀菌
            </li>


            <li class="li3">
              <router-link :to="'/equipment/timer/fan/' + this.getId()">
                <span></span>
                定时
              </router-link>
            </li>

          </ul>
        </div>

        <div class="list list_normal list_no_arrow list_info" style="margin-top:10px">
          <div class="item">
            <div class="clear">
              <p>
                当前风速
                <span class="right" @click="showWindSpeed()">
									{{
                    // equipmentFanMode==1?'on':
                    this.eqInfo.dehumidification.windSpeed === '1'
                        ? '低速' // equipmentFanMode==2?'循环':
                        : this.eqInfo.dehumidification.windSpeed === '2'
                            ? '中速'
                            : this.eqInfo.dehumidification.windSpeed === '3'
                                ? '高速'
                                : 'x'
                  }}
                  <!--              <a class="editWind">修改</a>-->
								</span>
              </p>
            </div>

          </div>
          <div class="item">
            <div class="clear">
              <p>
                循环模式
                <span class="right" @click="changeLoopMode()">
									{{
                    // equipmentFanMode==1?'on':
                    this.eqInfo.dehumidification.loopMode === '1'
                        ? '外循环' // equipmentFanMode==2?'循环':
                        : this.eqInfo.dehumidification.loopMode === '0'
                            ? '内循环'
                            : 'x'
                  }}
                  <!--              <a class="editWind">修改</a>-->
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                杀菌模式
                <span class="right" @click="showWindSpeed()">
									{{
                    // equipmentFanMode==1?'on':
                    this.eqInfo.dehumidification.sterilizationMode === '1'
                        ? '已开启' // equipmentFanMode==2?'循环':
                        : this.eqInfo.dehumidification.sterilizationMode === '0'
                            ? '已关闭'
                            : 'x'
                  }}
                  <!--              <a class="editWind">修改</a>-->
								</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>
                场景
                <span class=" right yh">
									<span class="yh2">{{ eqInfo.sceneName }}</span>
									{{ eqInfo.roomName }}
									<i class="icon-edit" @click="chooseScene"></i>
								</span>
              </p>
            </div>
          </div>
        </div>
      </div>


      <div class="tip detail_tip" v-show="showTip">
        <div class="content">
          <div class="tip_body">
            <div class="modal-warning">
              <span></span>
              <p>温馨提示：请关机后再切换模式</p>
            </div>
          </div>
          <div class="tip_foot tip_foot_detail"><span @click="hideModal">取消</span></div>
        </div>
      </div>
    </div>

    <!--        关机提示-->
    <div class="tip detail_tip" v-show="closeTip">
      <div class="content">
        <div class="tip_body closeTip_body">
          <div class="modal-warning">
            <span :class="this.closeIcon"></span>
            <p>{{ this.closeText }}</p>
          </div>
        </div>
      </div>
    </div>

    <mt-popup v-model="showModel" modal="false" class="pubPopup" popup-transition="popup-fade" position="bottom">
      <p class="tipText">模式切换</p>
      <mt-radio title="" v-model="dehumidificationMode"
                :options="modelListFan"></mt-radio>
      <!-- <div class="btns"> -->
      <p class="p-ui">
        <mt-button size="large" class="btn-orange" @click="changeMode">确定</mt-button>
      </p>
      <p class="p-ui2">
        <mt-button size="large" @click="cancelModel">取消</mt-button>
      </p>
    </mt-popup>

    <mt-popup v-model="showLoopModel" modal="false" class="pubPopup" popup-transition="popup-fade" position="bottom">
      <p class="tipText">循环模式切换</p>
      <mt-radio title="" v-model="loopMode"
                :options="loopModelList"></mt-radio>
      <p class="p-ui">
        <mt-button size="large" class="btn-orange" @click="changeLoopMode">确定</mt-button>
      </p>
      <p class="p-ui2">
        <mt-button size="large" @click="cancelModel">取消</mt-button>
      </p>
    </mt-popup>


    <mt-popup v-model="popupVisible" modal="false" class="pubPopup" popup-transition="popup-fade" position="bottom">
      <p class="tipText">修改风速</p>
      <mt-radio title="" v-model="windSpeed" :options="checklist"></mt-radio>
      <p class="p-ui">
        <mt-button size="large" class="btn-orange" @click="adjustWindSpeedFan">确定</mt-button>
      </p>
      <p class="p-ui2">
        <mt-button size="large" @click="cancelTimer">取消</mt-button>
      </p>
      <!-- </div> -->
    </mt-popup>

    <!--    温度切换-->
    <mt-popup v-model="showDegrees" class="pubPopup" defaultIndex="[3]" position="bottom" @touchmove.stop.prevent>
      <p class="tipText tip-text-border">湿度选择</p>
      <mt-picker
          :slots="coolMain"
          @change="onValuesChange"
          ref="mainDegrees"></mt-picker>
      <p class="p-ui">
        <mt-button size="large" class="btn-orange" @click="changeDegree">确定</mt-button>
      </p>
      <p class="p-ui2">
        <mt-button size="large" @click="cancelDegreeModel">取消</mt-button>
      </p>
    </mt-popup>

    <!--解绑弹窗-->
    <div class="tip detail_tip" v-show="showUnBind">
      <div class="content">
        <div class="tip_body">
          <div class="modal-warning">
            <span></span>
            <p>温馨提示：确定解除绑定吗</p>
          </div>
        </div>
        <div class="tip_foot">
          <span @click="hideModalCom('showUnBind')">取消</span>
          <span @click="sureBind">确定</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Range, Toast, Popup, Radio, Indicator} from 'mint-ui';

export default {
  name: 'dehum',
  data() {
    return {
      rangeValue: 50,
      showRange: false,
      list: [],
      showMenu: false,
      showTip: false,
      eqId: this.$route.params.id,
      dehumidificationMode: null,
      windSpeed: null,
      loopMode: null,
      totalDegree: 100,
      eqInfo: {
        dehumidification: {}
      },
      fanMod: null,
      eqModeVal: null,
      type: 1,
      equipmentFanMode: 1, //(1:on 0:自动 2:循环 3: 低速 4: 中速 5: 高速)
      degrees: 0,
      popupVisible: false,
      eqFlag: 1,
      stopRequest: false,
      showModel: false,
      showLoopModel: false,
      alreadyLoad: false,
      checklist: [
        {
          value: '1',
          label: '低速'
        },
        {
          value: '2',
          label: '中速'
        },
        {
          value: '3',
          label: '高速'
        }
      ],
      value: '10',
      modelList: [
        {
          value: '2',
          label: '制热'
        },
        {
          value: '1',
          label: '制冷'
        }
      ],
      loopModelList: [
        {
          value: '0',
          label: '内循环'
        },
        {
          value: '1',
          label: '外循环'
        }
      ],
      modelListFan: [
        {
          value: '0',
          label: '自动模式'
        },
        {
          value: '1',
          label: '新风模式'
        },
        {
          value: '2',
          label: '除湿模式'
        }
      ],
      showDegrees: false,
      valueDegrees: null,
      hotMain: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center',
          value: 15,
          defaultIndex: 10
        }
      ],
      coolMain: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center',
          value: 25,
          defaultIndex: 5
        }
      ],
      slotsFan: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center'
        }
      ],
      roomTep: null,
      firstRequest: true,
      isRequest: true,
      showEmpty: false,
      showUnBind: false,
      closeTip: false,
      closeText: '关机中...',
      closeIcon: 'icon-loading-off',
      path: this.$websocketUrl,
      socket: '',
      drawDegree: null
    };
  },
  beforeMount() {
    let num = this.totalDegree;
    let list = [];
    for (let i = 0; i < num; i++) {
      list.push(i);
    }
    this.list = list;
    setTimeout(() => {
      this.timer();
    }, 200);

    // 湿度范围
    let mainCool = [];
    for (let i = 40; i <= 65; i++) {
      mainCool.push(i);
    }
    this.coolMain[0].values = mainCool;

  },
  mounted() {
    this.isRequest = true;
    this.closeTimer = null;
    this.drawDegree = null;
    if (this.closeTimer) {
      clearInterval(this.closeTimer);
    }
    this.init();
  },
  beforeDestroy() {
    this.stopRequest = true;
    // this.socketclose();
  },
  methods: {
    init() {
      this.drawCircle();
      if (this.getId()) {
        this.eqDetail(this.getId());
      }
    },
    getId() {
      return this.$route.params.id;
    },
    changeDegree() {
      let degree = this.valueDegrees[0];
      this.adjustHeatTemperatureFan(degree);
    },
    initDraw() {
      // let degrees = this.eqInfo.equipmentRoomTemperature;
      let degrees = this.eqInfo.dehumidification.humidity
      // let degrees = this.drawDegree;
      this.drawPointer(degrees);
      this.drawGreenCricle(degrees);
      this.drawCircle(degrees);
    },
    eqDetail(id) {
      this.Api.eqDetail(
          id,
          (msg) => {
            this.eqInfo = msg.data;
            //初始化websocket
            if (typeof WebSocket === 'undefined') {
              alert('您的浏览器不支持socket');
            } else {
              this.socket = this.$store.state.websocket
              if (!this.socket) {
                this.socket = new WebSocket(this.$websocketUrl + this.eqInfo.iotDeviceId);
              }
              // 监听socket连接
              this.socket.onopen = this.socketopen;
              // 监听socket错误信息
              this.socket.onerror = this.socketerror;
              // 监听socket消息
              this.socket.onmessage = this.getMessage;
              // 关闭socket消息
              this.socket.onclose = this.socketclose;
              this.$store.commit('setWebSocket', this.socket);
            }
            if (this.eqInfo.dehumidification) {
              this.eqModeVal = String(this.eqInfo.dehumidification.systemStatus);
              this.drawDegree = this.eqInfo.dehumidification.humidity;
              this.value = this.eqInfo.dehumidification.fanMod + ''
            } else {
              this.eqInfo.dehumidification = {
                systemStatus: 0
              }
            }

            this.initDraw();
          },
      );
    },
    eqDel() {
      let params = {};
      params.id = this.eqId;
      this.Api.eqDel(params, msg => {
        if (msg.code == 200) {
          let str = 'pageNo=1';
          this.eqList(str);
        } else {
          Toast(msg.message);
        }
      });
    },
    eqStart() {
      // let str = 'id=' + this.getId();
      let data = {
        'iotDeviceId': this.getId(),
      }
      this.Api.dehumStartUp(data, (msg) => {
        if (msg.code === 200) {
          // Toast('开机成功');
          this.closeInterval(1);
        } else {
          Toast(msg.message);
        }
      });
    },
    changeEqSterilazation() {
      let sterilizationMode = '1'
      if (this.eqInfo.dehumidification.sterilizationMode === '1') {
        sterilizationMode = '0'
      }
      let data = {
        'iotDeviceId': this.getId(),
        'sterilizationMode': sterilizationMode
      }
      this.Api.sterilizationMode(data, (msg) => {
        if (msg.code === 200) {
          if (sterilizationMode === '0')
            Toast('已关闭杀菌功能');
          else
            Toast('已开启杀菌功能');
          // this.closeInterval(1);
        } else {
          Toast(msg.message);
        }
      });
    },

    closeInterval(flag) {
      this.closeTip = true;
      let type = '关机';
      this.closeIcon = 'icon-loading-off';
      if (flag == 1) {
        type = '开机';
        this.closeIcon = 'icon-loading-on';
      }
      let str = 'id=' + this.getId();
      let time = 5;
      this.closeText = type + '中 ' + time + '秒';
      this.closeTimer = setInterval(() => {
        time--;
        this.closeText = type + '中 ' + time + '秒';
        if (time <= 0) {
          this.closeTip = false;
          clearInterval(this.closeTimer);
          time = 10;
          Toast(type + '成功');
          this.init();
        }
      }, 1000);
    },

    shutDownFan() {
      // let str = 'id=' + this.getId();
      let data = {
        'iotDeviceId': this.getId(),
      }
      console.log(data)
      this.Api.dehumStartDown(data, (msg) => {
        if (msg.code === 200) {
          // Toast('关机成功');
          this.closeInterval();
          // this.closeTip = false;
          // clearInterval(this.closeTimer);
          // this.init();
        } else {
          Toast(msg.message);
        }
      });
    },
    // 切换循环模式
    changeDehumidificationMode(val) {
      let data = {
        'iotDeviceId': this.getId(),
        'dehumidificationMode': val
      }
      this.Api.dehumidificationMode(data, (msg) => {
        if (msg.code === 200) {
          Toast('切换模式成功');
          this.hideModal();
          this.init();
        } else {
          Toast(msg.message);
          this.hideModal();
          this.eqModeVal = String(this.eqMode);
        }
      });
    },
    // 切换循环模式
    updateLoopMode(val) {
      let data = {
        'iotDeviceId': this.getId(),
        'loopMode': val
      }
      this.Api.loopMode(data, (msg) => {
        if (msg.code === 200) {
          this.$set(this.eqInfo.dehumidification, 'loopMode', val);
          Toast('切换模式成功');
          this.hideModal();
          // this.init();
        } else {
          Toast(msg.message);
          this.hideModal();
          this.eqModeVal = String(this.eqMode);
        }
      });
    },

    // 调节制热温度
    adjustHeatTemperatureFan(temperature) {
      let data = {
        "iotDeviceId": this.getId(),
        'homeCoolingHumiditySetting': temperature,
      }
      console.log(data)
      this.Api.homeCoolingHumiditySetting(data, (msg) => {
        this.cancelDegreeModel();
        if (msg.code === 200) {
          this.init();
          // Toast('设置制热温度成功')
        } else {
          Toast(msg.message);
        }
      });
    },
    // 调节制冷温度
    adjustCoolTemperatureFan(temperature) {
      let data = {
        "iotDeviceId": this.getId(),
        'mac': this.eqInfo.number,
        "tempCool": temperature
      }
      this.Api.adjustCoolTemperatureFan(data, (msg) => {
        this.cancelDegreeModel();
        if (msg.code === 200) {
          this.init();
          // Toast('设置制冷温度成功')
        } else {
          Toast(msg.message);
        }
      });
    },
    // 展示风速列表
    showWindSpeed() {
      this.stopInit();
      this.windSpeed = this.eqInfo.dehumidification.windSpeed;
      this.popupVisible = true;
    },
    cancelTimer() {
      this.popupVisible = false;
    },
    adjustWindSpeedFan() {
      let data = {
        'iotDeviceId': this.getId(),
        'windSpeed':
        this.windSpeed
      };
      this.popupVisible = false;
      this.Api.windSpeed(data, (msg) => {
        if (msg.code === 200) {
          Toast('修改风速成功');
          this.eqInfo.dehumidification.windSpeed = this.windSpeed
        } else {
          Toast(msg.message);
        }
      });
    },
    hideSomething() {
      this.showRange = false;
      this.showMenu = false;
    },
    changRange(e) {
      this.closeEq(3);
    },
    changeMenu(e) {
      e.stopPropagation();
      this.showMenu = !this.showMenu;
    },
    timer() {
      let self = this;
      // new Swiper('.swiper-container', {
      //     initialSlide: this.degrees,
      //     slidesPerView: 'auto',
      //     centeredSlides: true,
      //     slideToClickedSlide: true,
      //     on: {
      //         slideChangeTransitionEnd: function () {
      //             // self.degrees = this.activeIndex;
      //             // self.watchDegree();
      //             // self.initDraw();
      //         },
      //     },
      // })
    },
    drawCircle() {
      var canvas = document.getElementById('clock');
      var ctx = canvas.getContext('2d');
      // 绘制外环
      ctx.beginPath();
      ctx.arc(110, 110, 100, (45 / 180) * Math.PI, (135 / 180) * Math.PI, true);
      ctx.strokeStyle = 'rgba(255,255,255,0.3)';
      ctx.lineWidth = '2';
      ctx.stroke();
      ctx.closePath();
      // 绘制灰色内环
      ctx.beginPath();
      ctx.arc(110, 110, 94, (45 / 180) * Math.PI, (135 / 180) * Math.PI, true);
      ctx.strokeStyle = 'rgba(255,255,255,0.3)';
      ctx.lineWidth = '5';
      ctx.stroke();
      ctx.closePath();

      //文字-刻度-line
      ctx.strokeStyle = 'rgba(255,255,255,0.6)';
      ctx.lineWidth = 1;
      // ctx.translate(canvas.width / 4, canvas.height / 4);

      //绘制表盘的刻度线
      let clockDimensions = 95;
      let total = (60 / 4) * 3;
      let showNUm = total - 6;
      for (var i = 6; i <= showNUm; i++) {
        if (i % 5 == 0) {
          ctx.save(); //保存当前绘制环境
          ctx.beginPath();
          ctx.lineWidth = 1;
          ctx.strokeStyle = 'rgba(255,255,255,0.3)';
          //重置坐标原点（0,0）
          //绘制环境旋转方法,以（0,0）为参考点进行旋转
          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate(((Math.PI * 2) / total) * i);
          ctx.moveTo(0, clockDimensions - clockDimensions / 20);
          ctx.lineTo(0, clockDimensions - clockDimensions / 7);
          ctx.stroke();
          ctx.beginPath();
          ctx.restore(); //恢复当前保存的绘制环境
        } else {
          ctx.save();
          ctx.beginPath();
          ctx.strokeStyle = 'rgba(255,255,255,0.3)';
          ctx.lineWidth = 1;
          //重置坐标原点（0,0）
          //绘制环境旋转方法,以（0,0）为参考点进行旋转
          ctx.translate(canvas.width / 2, canvas.height / 2);
          ctx.rotate(((Math.PI * 2) / total) * i);
          ctx.moveTo(0, clockDimensions - clockDimensions / 20);
          ctx.lineTo(0, clockDimensions - clockDimensions / 7);
          ctx.stroke();
          ctx.restore();
        }
      }
    },
    drawGreenCricle(val) {
      var canvas = document.getElementById('clock');
      var ctx = canvas.getContext('2d');
      canvas.height = canvas.height;
      let total = this.totalDegree;
      let rate = val / total;
      // 绘制绿色内环
      ctx.beginPath();
      ctx.arc(110, 110, 94, 0.75 * Math.PI, (1.5 * rate + 0.75) * Math.PI, false);
      ctx.strokeStyle = '#38FFEE';
      ctx.lineWidth = '5';
      ctx.stroke();
      ctx.closePath();
    },
    drawPointer(val) {
      var canvas = document.getElementById('pointer');
      var ctx = canvas.getContext('2d');
      canvas.height = canvas.height;

      let total = this.totalDegree;
      let rate = val / total;

      // 圆心和半径
      let cx = 110, cy = 110, r = 94;

      // 计算弧线终点角度
      let endAngle = (1.5 * rate + 0.75) * Math.PI;

      // 计算终点坐标
      let x = cx + r * Math.cos(endAngle);
      let y = cy + r * Math.sin(endAngle);

      // 在终点画小圆点
      ctx.beginPath();
      ctx.arc(x, y, 10, 0, 2 * Math.PI);
      ctx.fillStyle = '#38FFEE';
      ctx.fill();
      ctx.closePath();
    },
    hideModal() {
      this.showTip = false;
      this.startInit();
      this.cancelModel();
    },
    closeEq(flag) {
      this.stopInit();
      this.showTip = true;
      // if (this.eqMode != flag) {
      //   this.showTip = true;
      //   this.eqFlag = flag;
      // }
    },
    changeMode() {
      let flag = this.dehumidificationMode;
      this.changeDehumidificationMode(flag)
    },
    changeLoopMode() {
      let flag = this.loopMode;
      this.updateLoopMode(flag)
    },
    cancelModel() {
      this.showModel = false;
      this.showLoopModel = false;
      this.startInit();
    },
    stopInit() {
      this.stopRequest = true;
    },
    startInit() {
      // this.stopRequest = false;
      // setTimeout(() => {
      //   this.init();
      // }, 5 * 1000);
    },
    eqUnbind() {
      this.showModalCom('showUnBind');
    },
    sureBind() {
      // let str = 'id=' + this.getId();
      let data = {
        "iotDeviceId": this.getId()
      }
      this.Api.eqUnbind(data, msg => {
        this.showUnBind = false;
        if (msg.code == 200) {
          localStorage.setItem('isLo', 1);
          Toast('设备解绑成功');
          this.$router.push({
            path: '/equipment'
          });
        }
        if (msg.code == 402) {
          Toast(msg.message);
        }
      });
    },
    changeEqMode() {
      this.stopInit();
      this.dehumidificationMode = this.eqInfo.dehumidification.dehumidificationMode;
      this.showModel = true

    },
    changeEqLoopMode() {
      this.stopInit();
      this.loopMode = this.eqInfo.dehumidification.loopMode;
      this.showLoopModel = true
    },
    onValuesChange(picker, values) {
      this.valueDegrees = values;
    },
    showDegreeModel() {
      let coolTemp = parseInt(this.eqInfo.dehumidification.homeCoolingHumiditySetting);
      this.coolMain[0].defaultIndex = Math.abs(coolTemp - 40)
      this.stopInit();
      this.showDegrees = true;
    },
    cancelDegreeModel() {
      this.startInit();
      this.showDegrees = false;
    },
    goBack() {
      this.$router.push({path: '/equipment'});
    },
    hideModalCom(key) {
      this.showUnBind = false;
    },
    showModalCom(key) {
      this[key] = true;
    },
    chooseScene() {
      this.$router.push({path: this.PATH.getChooseHome() + '2?id=' + this.getId()});
    },
    socketopen: function () {
      console.log('socket连接成功');
    },
    socketerror: function () {
      console.log('连接错误');
    },
    getMessage: function (msg) {
      // this.drawDegree = msg.data;
      //

      console.log(msg);

      let data = JSON.parse(msg.data)

      if (data.co2 !== undefined) {
        this.eqInfo.dehumidification.cc = data.co2;
      }
      //设备上设定的制热的温度
      if (data.dehumidificationMode !== undefined) {
        this.eqInfo.dehumidification.dehumidificationMode = data.dehumidificationMode;
      }
      if (data.humidity !== undefined) {
        this.eqInfo.dehumidification.humidity = data.humidity;
        this.drawDegree = this.eqInfo.dehumidification.humidity
        this.initDraw();
      }
      if (data.loopMode !== undefined) {
        this.eqInfo.dehumidification.loopMode = data.loopMode;
      }
      if (data.pm25 !== undefined) {
        this.eqInfo.dehumidification.pm25 = data.pm25;
        this.value = this.eqInfo.dehumidification.pm25 + ''
      }
      if (data.systemStatus !== undefined) {
        this.eqInfo.dehumidification.systemStatus = data.systemStatus;
        this.eqModeVal = data.systemStatus
      }
      if (data.sterilizationMode !== undefined) {
        this.eqInfo.dehumidification.sterilizationMode = data.sterilizationMode;
      }
      if (data.windSpeed !== undefined) {
        this.eqInfo.dehumidification.windSpeed = data.windSpeed;
      }
      if (data.homeCoolingHumiditySetting !== undefined) {
        this.eqInfo.dehumidification.homeCoolingHumiditySetting = data.homeCoolingHumiditySetting
      }
    }
  },
  socketclose: function () {
    console.log('socket已经关闭');
    // this.socket.close();
  }
};
</script>
<style scoped>
@import url('../../../assets/list.css');
@import url('../../tip/tip.css');
@import url('index.css');

.noDegree {
  font-size: 23px !important;
}

.yh {
  display: inline-block;
  max-width: 85%;
  text-align: right;
}

.yh2 {
  display: inline-block;
  max-width: 60%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.p-ui {
  padding: 20px 10px;
}

.p-ui2 {
  padding: 0 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/freshAir/dehum/index.vue